// src/utils/dateRangeLimitMixin.js

export default {
    data() {
        return {
            dateLimitMixinField: '', // 绑定字段路径，例如 'queryParams.createDates'
            limitMonth: 1, // 限制时间范围，单位：月
            startPickerTime: '', // 记录用户第一次选的时间点
            pickerOptions: {
                disabledDate: () => false,
                onPick: null
            },
            _dateLimitWatcherInited: false // 防止重复 watch
        };
    },

    methods: {
        /**
         * 初始化限制逻辑
         * @param {string} fieldPath 绑定字段路径，例如 'queryParams.createDates'
         * @param {object} extraOptions 额外的 pickerOptions，比如快捷方式
         */
        initDateLimitMixin(fieldPath, extraOptions = {}) {
            if (!fieldPath) {
                console.warn('[dateLimitMixin] 缺少字段路径参数');
                return;
            }
            this.dateLimitMixinField = fieldPath;
            // 更严谨的加月份方法，避免月底跳月 bug
            const addMonths = (date, num) => {
                const d = new Date(date);
                const day = d.getDate();
                d.setDate(1);
                d.setMonth(d.getMonth() + num);
                const maxDay = new Date(d.getFullYear(), d.getMonth() + 1, 0).getDate();
                d.setDate(Math.min(day, maxDay));
                return d;
            };
            // 绑定 onPick 行为（首次选择后限制范围）
            this.pickerOptions = {
                ...this.pickerOptions,
                ...extraOptions,
                onPick: ({
                    minDate,
                    maxDate
                }) => {
                    if (minDate && !maxDate) this.startPickerTime = minDate;
                    else if (!minDate && maxDate) this.startPickerTime = maxDate;
                    else this.startPickerTime = '';
                    this.pickerOptions.disabledDate = (date) => {
                        if (!this.startPickerTime) return false;
                        const min = addMonths(this.startPickerTime, -this.limitMonth).getTime();
                        const max = addMonths(this.startPickerTime, this.limitMonth).getTime();
                        return date.getTime() < min || date.getTime() > max;
                    };
                }
            };
            // 初始化 watch，只绑定一次
            if (!this._dateLimitWatcherInited) {
                this.$watch(
                    () => this.getFieldValue(fieldPath),
                    (val) => {
                        if (!val || val.length === 0) {
                            this.startPickerTime = '';
                            this.pickerOptions.disabledDate = () => false;
                            this.resetDatePickerView();
                        }
                    }, {
                        deep: true
                    }
                );
                this._dateLimitWatcherInited = true;
            }
        },
        /**
         * 校验时间范围是否超出限制
         */
        checkDateLimitRange() {
            const val = this.getFieldValue(this.dateLimitMixinField);
            if (!val || val.length !== 2) return;
            const [start, end] = val;
            const s = new Date(start);
            const e = new Date(end);
            const limitDate = this.addMonthsStrict(s, this.limitMonth);
            limitDate.setHours(23, 59, 59, 999); // 设置为当天最后一毫秒
            if (e > limitDate) {
                this.$message.warning(`时间范围不能超过 ${this.limitMonth} 个月`);
                this.setFieldValue(this.dateLimitMixinField, []);
                this.startPickerTime = '';
                this.resetDatePickerView();
            }
        },
        /**
         * 校验日期范围是否超过限制
         * 超过则清空绑定字段，提示用户
         */
        // checkDateLimitRange() {
        //     const val = this.getFieldValue(this.dateLimitMixinField);
        //     if (!val || val.length !== 2) return;
        //     const [start, end] = val;
        //     const isOverLimit = (startDate, endDate) => {
        //         const s = new Date(startDate);
        //         const e = new Date(endDate);
        //         const yearDiff = e.getFullYear() - s.getFullYear();
        //         const monthDiff = e.getMonth() - s.getMonth();
        //         const totalMonths = yearDiff * 12 + monthDiff;
        //         if (totalMonths > this.limitMonth) return true;
        //         if (totalMonths === this.limitMonth && e.getDate() > s.getDate()) return true;
        //         return false;
        //     };
        //     if (isOverLimit(start, end)) {
        //         this.$message.warning(`时间范围不能超过 ${this.limitMonth} 个月`);
        //         this.setFieldValue(this.dateLimitMixinField, []);
        //         this.startPickerTime = '';
        //         // 重新初始化限制逻辑，防止残留状态
        //         this.initDateLimitMixin(this.dateLimitMixinField);
        //     }
        // },
        /**
         * 重置 DatePicker 的内部视图状态，解决清空后“选中为结束时间”的问题
         */
        resetDatePickerView() {
            this.$nextTick(() => {
                const picker = this.$refs.dateRangePicker;
                if (picker && picker.picker) {
                    picker.picker.resetView && picker.picker.resetView();
                    picker.picker.rangeState = {
                        selecting: false
                    };
                }
            });
        },
        /**
         * 用于 @change 绑定，自动校验或清空逻辑
         */
        handleDateLimitChange(val) {
            if (!val || val.length === 0) {
                this.startPickerTime = '';
                this.setFieldValue(this.dateLimitMixinField, []);
                this.pickerOptions.disabledDate = () => false;
                this.resetDatePickerView();
            } else {
                this.checkDateLimitRange();
            }
        },
        /**
         * 工具：安全地增加月份，避免月末跳月
         */
        addMonthsStrict(date, num) {
            const d = new Date(date);
            const day = d.getDate();
            d.setDate(1);
            d.setMonth(d.getMonth() + num);
            const maxDay = new Date(d.getFullYear(), d.getMonth() + 1, 0).getDate();
            d.setDate(Math.min(day, maxDay));
            return d;
        },

        /**
         * 根据路径获取值，例如 'queryParams.createDates'
         */
        getFieldValue(path) {
            const keys = path.split('.');
            return keys.reduce((obj, key) => (obj && obj[key] != null ? obj[key] : undefined), this);
        },

        /**
         * 根据路径设置值，Vue2 使用 $set 保证响应式
         */
        setFieldValue(path, value) {
            const keys = path.split('.');
            const lastKey = keys.pop();
            let obj = this;
            for (let key of keys) {
                if (!(key in obj)) this.$set(obj, key, {});
                obj = obj[key];
            }
            this.$set(obj, lastKey, value);
        }
    }
};


// WEBPACK FOOTER //
// ./src/utils/dateRangeLimitMixin.js